import type { ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;
const prefix = '/api/v1/notification';

/**
 * @description 通知相关接口
 */
export const notificationApi = {
  /**
   * @description 获取通知列表
   */
  getNotificationList(user: number): ResponseType {
    return request({
      url: prefix + '/list',
      method: 'GET',
      params: {
        user: user,
      },
    });
  },

  /**
   * @description 标记通知为已读
   * @param notificationId 通知ID
   */
  markNotificationIsRead(notificationId: number[]): ResponseType {
    return request({
      url: prefix + '/isRead',
      method: 'POST',
      data: {
        notificationId: notificationId,
      },
    });
  },

  /**
   * @description 创建通知
   * @param title 通知标题
   * @param content 通知内容
   */
  createNotification(user: number, title: string, content: string, link: string): ResponseType {
    return request({
      url: prefix + '/create',
      method: 'POST',
      data: {
        user: user,
        title: title,
        content: content,
        link: link,
      },
    });
  },

  deleteReadNotification(user: number): ResponseType {
    return request({
      url: prefix + '/deleteRead',
      method: 'POST',
      data: {
        user: user,
      },
    });
  },
};
